export default __webpack_public_path__ + "static/media/bmj-loader.bdd633cd.gif";